<template>
    <div class="regist">
        <h3>{{ $TL.registerAccount }}</h3>
        <div class="regist-slot">
            <v-form
                v-model="valid"
                ref="form"
                lazy-validation
                @keyup.enter="regist"
            >
                <label for="">
                    <span>{{ $TL.nickName }}：</span>
                    <v-text-field
                        v-model="nickname"
                        :counter="30"
                        :rules="contentRules"
                        required
                    />
                </label>
                <label for="">
                    <span>{{ $TL.username }}：</span>
                    <v-text-field
                        v-model="username"
                        class="username"
                        :counter="30"
                        :rules="(contentRules, usernameRules)"
                        :error-messages="error.username"
                        @keyup.enter="regist"
                        required
                    />
                </label>
                <label for="" class="password-ctl">
                    <span>{{ $TL.enterPassword }}：</span>
                    <v-text-field
                        v-model="password"
                        :rules="passwordRules"
                        :counter="20"
                        :type="inputType"
                        @keyup.enter="regist"
                        required
                    />
                    <v-btn
                        class="check-lock"
                        :ripple="false"
                        @mousedown="check_password(true)"
                        @mouseup="check_password(false)"
                    >
                        <v-icon>mdi-{{ seeIcon }}</v-icon>
                    </v-btn>
                </label>
                <v-btn class="save-btn def gradient-bg" @click="regist">{{
                    $TL.createAccount
                }}</v-btn>
            </v-form>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
import { regist_login } from "./components/login-regist";

export default {
    name: "regist",

    data() {
        return {
            valid: true,
            contentRules: [
                v => !!v || this.$TL.contentCanNotNull,
                v => v.length <= 30 || this.$TL.lengthCannotExceed30Char
            ],
            passwordRules: [
                v => !!v || this.$TL.contentCanNotNull,
                v =>
                    (v && v.length >= 4) ||
                    this.$TL.lengthCannotLessThan4digits,
                v => (v && v.length <= 20) || this.$TL.lengthCannotExceed20Char
            ],
            usernameRules: [
                v => !!v || this.$TL.contentCanNotNull,
                v =>
                    /^[a-zA-Z0-9@_-]{4,30}$/.test(v) ||
                    "应为4到30位（字母，数字，_，-，@）"
            ],
            nickname: "",
            username: "",
            password: "",
            inputType: "password",
            seeIcon: "eye-off",
            error: {
                username: ""
            }
        };
    },
    computed: {
        ...mapState("global", [])
    },
    components: {},
    created() {},
    mounted() {},
    beforeDestroy() {},
    methods: {
        //  注册请求
        async regist() {
            let option = {
                username: this.username,
                password: this.password,
                name: this.nickname
            };
            let msg = await regist_login(
                "profile/register",
                this.$refs.form,
                option
            );
            this.error.username = msg?.errors?.username ?? "";
        },

        //  查看密码
        check_password(show) {
            if (show) {
                this.inputType = "text";
                this.seeIcon = "eye";
            } else {
                this.inputType = "password";
                this.seeIcon = "eye-off";
            }
        }
    }
};
</script>

<style lang="scss">
.regist {
    padding: 16px 12px;
    .v-dialog {
        width: 400px;
    }

    .v-input__slot {
        &::before,
        &::after {
            display: none;
        }
        padding: 0 10px;
        height: 40px;
        margin-top: 8px;
    }

    .regist-slot {
        margin-top: 24px;
        padding: 0 24px;
        label {
            width: 100%;
            margin-bottom: 16px;

            span {
                font-size: 14px;
            }
        }

        .save-btn {
            width: 160px;
            margin: 20px auto 0 auto;
        }

        .v-input__slot {
            border: 1px solid #dfe1e5;
            font-size: 14px;
            border-radius: $border-radius;
        }
    }

    .check-lock {
        bottom: 24px;
    }

    .v-text-field__details {
        transform: translateY(5px);

        .v-messages {
            display: block;
        }

        .v-counter {
            display: none;
        }
    }
}
</style>
